var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { operatorByFieldType } from "@/components/fields/search";
import { useGetModuleFieldDefsQuery, useGetModuleFieldsQuery, } from "@/store/api";
import { Input, Option, Select } from "@mui/joy";
import copy from "fast-copy";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
export default function FieldEditor(_a) {
    var filter = _a.filter, onFilterUpdated = _a.onFilterUpdated, module = _a.module;
    var filters = copy(filter);
    var t = useTranslation(["common", module || "Accounts"]).t;
    var _b = useState(), fields = _b[0], setFields = _b[1];
    var _c = useState(), fieldDefs = _c[0], setFieldDefs = _c[1];
    var _d = useState(true), displayValue = _d[0], setDisplayValue = _d[1];
    var _e = useGetModuleFieldsQuery(module || "Accounts"), listFields = _e.data, isLoading = _e.isLoading, isError = _e.isError, isFetching = _e.isFetching;
    var listFieldDefs = useGetModuleFieldDefsQuery(module || "Accounts").data;
    var _f = useState(), operatorsMatch = _f[0], setOperatorsMatch = _f[1];
    var LIST_OPERATOR_NO_VALUE = ["isnull", "notnull"];
    var data = (listFields && Object.entries(listFields === null || listFields === void 0 ? void 0 : listFields.data.attributes)) || [];
    var dataViewDefs = (listFieldDefs && listFieldDefs.data.layout) || [];
    var findFieldType = function (fielNname) {
        var _a, _b;
        var fieldType = data === null || data === void 0 ? void 0 : data.find(function (element) { return element[1].name === fielNname; });
        setOperatorsMatch(fieldType && ((_a = fieldType[1]) === null || _a === void 0 ? void 0 : _a.type) && operatorByFieldType((_b = fieldType[1]) === null || _b === void 0 ? void 0 : _b.type));
    };
    useEffect(function () {
        setFields(data);
        setFieldDefs(dataViewDefs);
        findFieldType(filter.field);
    }, [listFields, filter, listFieldDefs]);
    var onChangeFieldHandler = function (value) {
        findFieldType(value);
        onFilterUpdated(__assign(__assign({}, filters), { field: value }));
    };
    var isOperatorNoValue = function (value) {
        if (LIST_OPERATOR_NO_VALUE.includes(value)) {
            return true;
        }
        else {
            return false;
        }
    };
    var onChangeOperatorHandler = function (value) {
        setDisplayValue(true);
        if (value && isOperatorNoValue(value)) {
            onFilterUpdated(__assign(__assign({}, filters), { operator: value, value: "" }));
            setDisplayValue(false);
        }
        else {
            onFilterUpdated(__assign(__assign({}, filters), { operator: value }));
        }
    };
    return (_jsxs("div", __assign({ className: "flex " }, { children: [_jsx("span", { children: _jsx(Select, __assign({ className: " mb-2", placeholder: "Select option", onChange: function (event, value) {
                        value && onChangeFieldHandler(value);
                    }, size: "sm", value: filter.field }, { children: fieldDefs &&
                        (fieldDefs === null || fieldDefs === void 0 ? void 0 : fieldDefs.map(function (item, index) { return (_jsx(Option, __assign({ value: item.name }, { children: t(item.label, { ns: module || "Accounts" }) }), index)); })) })) }), _jsx("span", __assign({ className: "mx-4" }, { children: filter.field && (_jsx(Select, __assign({ className: "mb-2", placeholder: "Select option", onChange: function (event, value) {
                        value && onChangeOperatorHandler(value);
                    }, size: "sm", value: filter.operator }, { children: operatorsMatch &&
                        Object.values(operatorsMatch).map(function (op, index) { return (_jsx(Option, __assign({ value: op.value }, { children: op.label }), index)); }) }))) })), _jsx("span", { children: displayValue &&
                    filter.field &&
                    filter.operator &&
                    !isOperatorNoValue(filter.operator) && (_jsx(Input, { onChange: function (event) {
                        return onFilterUpdated(__assign(__assign({}, filters), { value: event.target.value }));
                    }, size: "sm", value: filter.value })) })] })));
}
